import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import { FormField } from 'rmwc/FormField';
import ReactGA from 'react-ga';

class LearningResourceHome extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    			taxonomyDetails: [],
    			aspectTags: ''
    		}
    	}
    }

    handleBackAction = (e) => {
    	e.preventDefault()
    	this.props.history.push('/portal/app/learning_resources/my_learning_plan')
    }

    handleView = (e, taxonomyTypeId, taxonomyName) => {
		e.preventDefault()
		let viewFromSwot = false
		this.props.history.push(`/portal/app/user/resources/${viewFromSwot}/${taxonomyTypeId}/${taxonomyName}`)
	}

	handleAspectsTag = (tagString) => {
		let data = Object.assign({}, this.state.data)

		data.aspectTags = tagString
		this.setState({data: data})
	}

	handleBuzzword = (e) => {
        e.preventDefault()
        let typeName = 'user'
        this.props.history.push(`/portal/app/learning_resources/search/${typeName}`)
    }

	componentDidMount() {
		let data = Object.assign({}, this.state.data)

		ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview('/build_my_learning_plan');
        
        let taxId = 3 
		let fetchTax = `user/learning_resource/taxonomy/${taxId}`
		return api.getUserResponse(this.props.user.accessToken, fetchTax)
		.then((result) => {
			if (result.status === 'success'){
				data.taxonomyDetails = result.data
				this.setState({data: data})
			}
		})
	}
	
	render() {
		let handleView = this.handleView
		let handleBuzzword = this.handleBuzzword
		let handleAspectsTag = this.handleAspectsTag
		let handleBackAction = this.handleBackAction
		let individualTaxonomy, documentComponent

		documentComponent = (
			<Grid>
				<GridCell span="3">
					<Typography align="left"><a href='https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/centastandards/Standards_Overview.pdf' target="_blank" style={{cursor: 'pointer'}}>Overview of CENTA Standards</a></Typography>
				</GridCell>
				<GridCell span="3">
					<Typography align="left"><a href='https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/centastandards/CENTA_Standards_Complete.pdf' target="_blank" style={{cursor: 'pointer'}}>CENTA Standards Version 3</a></Typography>
				</GridCell>
			</Grid>
		)
		

		if (this.state.data.taxonomyDetails.length > 0) {
			individualTaxonomy = (
				<Grid>
					{this.state.data.taxonomyDetails.map(function(taxonomy){
						let taxonomyTypeId = taxonomy.id
						let taxonomyName = taxonomy.name
						let aspectsLinked
						if(taxonomy.tag_string !== null){
							aspectsLinked = (
								<Typography align="left" use="caption">CENTA Aspect <i>{taxonomy.tag_string}</i></Typography>
							)
						}
						else{
							console.log('Tag not available')
						}
						return (
							<GridCell span = "6" key = {taxonomyTypeId}>
								<Card style={{padding: '7px'}}>
									<Grid className="opportunity-list-item">
										<GridCell span = "10">
											{aspectsLinked}
											<Typography align="left"><br />{taxonomyName}</Typography>
										</GridCell>
										<GridCell span = "2">
											<Button dense style={{ width: '80%' }} onClick= {((e) => handleView(e, taxonomyTypeId, taxonomyName))}>View</Button>
										</GridCell>
									</Grid>
								</Card>
							</GridCell>
						)
					})}
				</Grid>
			)
		}
		return (
			<div>
				<Grid className="opportunity-list-item">
					<GridCell span = "12">
						<Card style={{padding: '0px'}}>
							<Grid className="opportunity-list-item">
								<GridCell span = "9">
	                            	<Typography use="headline5">MyCENTA Learning Resources</Typography>
	                            </GridCell>
	                            <GridCell span = "2">
							       	<Button raised style={{ width: '100%' }} onClick = {((e) => handleBuzzword(e))}>Search</Button>
							    </GridCell>
                        		<GridCell span = "1">
                            		<Button raised style={{ width: '100%' }} onClick = {((e) => handleBackAction(e))}>Back</Button>
                        		</GridCell>
                        	</Grid>
                        </Card>
					</GridCell>
				</Grid>
				{documentComponent}
				{individualTaxonomy}
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningResourceHome);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/LearningResourceHome.jsx